/* import __COLOCATED_TEMPLATE__ from './styles.hbs'; */
/* RESPONSIBLE TEAM: team-proactive-support */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file: 🚀 */
/* eslint-disable ember/no-classic-classes */
/* eslint-disable ember/no-classic-components */
import { computed } from '@ember/object';
import { reads } from '@ember/object/computed';
import { inject as service } from '@ember/service';
import Component from '@ember/component';
import { notImplemented } from '@intercom/pulse/lib/computed-properties';
import * as IntercomEmbed from '@intercom/intercom-embed';
import AppColor from 'embercom/lib/color';
import intercomMessengerColors from '@intercom/intercom-messenger-colors';
import { DARK_THEME_TYPE } from 'embercom/lib/messenger-settings/target-types';

export default Component.extend({
  tagName: '',
  messengerSettingsThemeProvider: service(),
  appColor: notImplemented(),
  stylesheetBody: computed('appColor', function () {
    if (IntercomEmbed && IntercomEmbed.getStylesheet) {
      return IntercomEmbed.getStylesheet().replace(/-intercom-app-color/g, this.appColor);
    } else {
      return '';
    }
  }),
  applicationColors: computed('appColor', function () {
    return new AppColor().generate_message_box_colors(this.appColor);
  }),
  messengerColors: computed(
    'appColor',
    'messengerSettingsThemeProvider.targetThemeType',
    function () {
      let themeMode =
        this.messengerSettingsThemeProvider?.targetThemeType === DARK_THEME_TYPE ? 'dark' : 'light';
      return intercomMessengerColors({
        primaryColor: this.appColor,
        contrastCheckMethod: themeMode === 'dark' ? 'contrast-ratio-4.5' : 'contrast-ratio-3.0',
        themeMode,
      });
    },
  ),
  buttonBackgroundColor: reads('messengerColors.button_background_color'),
  buttonTextColor: reads('messengerColors.button_text_color'),
});
